<template>
  <div class="carousel-container">
    <div class="carousel-track" :style="trackStyle">
      <div v-for="(item, index) in visibleItems" :key="index" class="carousel-card"
        :class="{ 'active': isActive(index) }" :style="getCardStyle(index)" @click.stop="handleClick(item)">
        <!-- 测试 -->
        <!-- <img src="https://picsum.photos/id/1018/600/800" :alt="item.title" class="card-image"> -->
        <!-- 正式 -->
        <img :src="item?.cover" :alt="item.title" class="card-image">
        <!-- 正式end -->
        <!-- <div class="card-overlay">
          <h3 class="card-title">{{ item.title }}</h3>
        </div> -->
      </div>
    </div>

    <button class="nav-button prev" @click="prev">‹</button>
    <button class="nav-button next" @click="next">›</button>
  </div>
</template>

<script>
  export default {
    name: 'CarouselCards',
    props: {
      imgUrl: {
        type: Object,
        default: {}, // 默认空数组
      },
      // 正式
      items: {
        type: Array,
        required: true,
        default: () => [],
        validator: value => {
          return value.every(item => {
            return 'cover' in item && 'title' in item && 'url' in item
          })
        }
      }
    },
    data() {
      return {

        // 测试
        // items: [{
        //     title: '产品一',
        //     image: 'https://picsum.photos/id/1018/600/800', // 改为竖图比例
        //     url: 'http://192.168.1.43:3000/submenu/hydt/subarticle/52'
        //   },
        //   {
        //     title: '产品二',
        //     image: 'https://picsum.photos/id/1015/600/800',
        //     url: 'http://192.168.1.43:3000/submenu/hydt/subarticle/52'
        //   },
        //   {
        //     title: '产品三',
        //     image: 'https://picsum.photos/id/1019/600/800',
        //     url: 'http://192.168.1.43:3000/submenu/hydt/subarticle/52'
        //   },
        //   {
        //     title: '产品四',
        //     image: 'https://picsum.photos/id/1020/600/800',
        //     url: 'http://192.168.1.43:3000/submenu/hydt/subarticle/52'
        //   },
        //   {
        //     title: '产品五',
        //     image: 'https://picsum.photos/id/1021/600/800',
        //     url: 'http://192.168.1.43:3000/submenu/hydt/subarticle/52'
        //   }
        // ],
        currentIndex: 2, // 当前中心索引
        itemWidth: 38.4, // 宽度减小以适应长图36
        itemHeight: 21.6, // 高度保持较大22
        spacing: -24,//22
        scaleFactor: 0.8
      }
    },
    computed: {
      trackStyle() {
        return {
          height: `${this.itemHeight}vw`
        }
      },
      visibleItems() {
        const items = []
        const length = this.items.length
        if (this.items.length > 0) {
          for (let i = -2; i <= 2; i++) {
            let index = (this.currentIndex + i + length) % length
            items.push(this.items[index])
          }
        }
        return items
      }
    },
    methods: {
      isActive(index) {
        return index === 2
      },
      getCardStyle(index) {
        const distance = index - 2
        const absDistance = Math.abs(distance)

        const translateX = distance * (this.itemWidth + this.spacing)
        const scale = Math.pow(this.scaleFactor, absDistance)
        const zIndex = 5 - absDistance
        const opacity = 1 - (absDistance * 0.2)

        return {
          width: `${this.itemWidth}vw`,
          height: `${this.itemHeight}vw`,
          transform: `translateX(${translateX}vw) scale(${scale})`,
          zIndex: zIndex,
          opacity: opacity
        }
      },
      prev() {
        this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length
      },
      next() {
        this.currentIndex = (this.currentIndex + 1) % this.items.length
      },
      handleClick(item) {
        console.log('点击了:', item.url);

        // 判断是否是外部链接
        const isExternal = item.url.startsWith('http');

        if (isExternal) {
          // 如果是外部链接，去掉协议和域名，只保留路径部分
          const path = item.url.replace(/^https?:\/\/[^/]+/, '');
          this.$router.push(this.localePath(path));
        } else {
          // 内部路由直接跳转
          this.$router.push(this.localePath(item.url));
        }
      },
      autoPlay() {
        this.interval = setInterval(() => {
          this.next()
        }, 3000)
      },
      stopAutoPlay() {
        clearInterval(this.interval)
      },
      handleResize() {
        if (window.innerWidth < 768) {
          this.itemWidth = 96
          this.itemHeight = 54
          this.spacing = 0
        } else {
          this.itemWidth = 38.4
          this.itemHeight = 21.6
          this.spacing = -24
        }
      }
    },
    mounted() {
      this.handleResize()
      this.autoPlay()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      this.stopAutoPlay()
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>

<style scoped>
  .carousel-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    /* margin: 1vw auto; */
    /* height: 24vw; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
  }

  .carousel-track {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .carousel-card {
    position: absolute;
    cursor: pointer;
    transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
    /* border-radius: 12px; */
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform-origin: center;
    background-color: #fff;
    /* left: 50%; */
    /* margin-left: -110px; /* 调整为一半宽度(220px/2) */
  }

  .carousel-card.active {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
    z-index: 5;
  }

  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .carousel-card:hover .card-image {
    transform: scale(1.05);
  }

  .card-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
    padding: 1vw;
    color: white;
    text-align: center;
  }

  .card-title {
    color: #fff;
    margin: 0;
    font-size: 1.4rem;
    font-weight: 500;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    border: none;
    font-size: 24px;
    color: #333;
    cursor: pointer;
    z-index: 20;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-button:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateY(-50%) scale(1.1);
  }

  .prev {
    left: 1vw;
  }

  .next {
    right: 1vw;
  }

  @media (max-width: 768px) {
    .carousel-container {
      /* height: 380px; */
      margin: 0 auto;
    }

    /* 调整为一半宽度(180px/2) */
    /* .carousel-card {
    margin-left: -90px;
  } */

    .card-overlay {
      padding: 15px;
    }

    .card-title {
      font-size: 1.2rem;
    }

    .nav-button {
      width: 40px;
      height: 40px;
      font-size: 20px;
    }

    .prev {
      left: 15px;
    }

    .next {
      right: 15px;
    }
  }
</style>
